import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { JmepDiscoverService } from './../../../../service/jmep-discover.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Options } from 'tabulator-tables';
import { DISCOVERY_TYPES } from './../../../datasource.entity.widget/models/types';
import { MatDialogRef } from '@angular/material/dialog';
import {
  DialogService,
  TabulatorService,
  FusionTransformationService,
  NotificationService,
  DateFormatterService,
  UserAuth
} from '@nrwl/common-lib';
import { ViaviTableComponent } from './../../../../../../../viavi-tabulator/src/lib/component/viavi-table/viavi-table.component';
import { JmepDiscoverDialogComponent } from '../jmep-discover-dialog/jmep-discover-dialog.component';

@Component({
  selector: 'nrwl-zero-touch-discovery',
  templateUrl: './zero-touch-discovery.component.html',
  styleUrls: ['./zero-touch-discovery.component.scss'],
  providers: [JmepDiscoverService]
})
export class ZeroTouchDiscoveryComponent implements OnInit, OnDestroy {
  @Input() selectedEsam: any;
  @ViewChild(ViaviTableComponent) ztpDiscoveryTable: ViaviTableComponent;
  discoveryMode = DISCOVERY_TYPES.ztp;
  hasReadWriteRole = false;
  isLoading = true;
  savingInProgress = false;
  isCheckBoxEnabled = true;
  disableRemoveAction = true;
  showDiscoveyResTable = false;
  lastUpdated = new Date().toLocaleString();
  dataOptions = {
    ipaddress: {
      sectionName: DISCOVERY_TYPES.ztp
    }
  };
  widgetOptions = {
    defaultSort: {
      id: "errorMsg",
      type: "text",
      reverse: true,
    },
    pagination: {
      itemsPerPage: 1000,
    },
  };
  requestJSONFormat = {
    format: "json",
    value: {
      data: []
    }
  };
  discoveryStatus = [];
  configuredIps = [];
  finalUpdatedFieldsOptions = [];
  formData = {};
  dataSource: any;
  tableObj: any;
  ztpJmepsTable: Options;
  esamId: string = null;
  esamName: string = null;
  esamURL: string = null;
  discoveryErrorMessage = null;
  activatedCount = 0;
  processedCount = 0;
  errorCount = 0;
  ztpDiscoverySates = [
    {
      title: "Discovered",
      count: 0,
      stateClass: "succeeded"
    },
    {
      title: "Activated",
      count: 0,
      stateClass: "succeeded"
    },
    {
      title: "Processed",
      count: 0,
      stateClass: "succeeded"
    },
    {
      title: "Error",
      count: 0,
      stateClass: "failed"
    }
  ];

  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(
    private jmepDiscoverService: JmepDiscoverService,
    private tabulatorService: TabulatorService,
    private fusionTransformationService: FusionTransformationService,
    private readonly dialogService: DialogService,
    private readonly notificationService: NotificationService,
    private readonly dateFormatterService: DateFormatterService,
    private readonly userAuth: UserAuth,
    public dialogRef: MatDialogRef<JmepDiscoverDialogComponent>,
  ) {
    this.hasReadWriteRole = this.userAuth.isAuthedFor('READ_WRITE');
    this.ztpJmepsTable = this.tabulatorService.commonTableConfiguration();
    this.ztpJmepsTable.persistenceID = 'jmeps-discovery';
    this.ztpJmepsTable.groupHeader = this.tabulatorService.groupHeader;
  }

  ngOnInit(): void {
    //this.selectedEsam = this.jmepDiscoverService.getSelectedEsamInfo();
    this.esamId = this.selectedEsam?.id;
    this.esamName = this.selectedEsam?.name;
    this.esamURL = this.selectedEsam?.dataItem?.connections?.[0]?.uri || "";
    this.getZTPDiscovery();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  getZTPDiscovery(): void {
    this.configuredIps = [];
    this.dataSource = [];
    this.tableObj = [];
    this.finalUpdatedFieldsOptions = [];
    this.jmepDiscoverService
    .getZTPDiscovery({url: this.esamURL})
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(response => {
      if(response){
        this.isLoading = false;
        this.zeroTouchDiscovered(response);
      }
    });
  }

  //eslint-disable-next-line
  zeroTouchDiscovered(response: any): void {
    if(response?.status === 'success' && response?.data?.value?.data?.length) {
        this.showDiscoveyResTable = true;
        const responseData = response.data.value.data;
        this. tableObj = responseData.map(item => this.getTableObject(item));
        this.dataSource = this.fusionTransformationService.transformData(
          'jmeps-discovery',
          this.tableObj
        );
        const activeColumns = Object.keys(this.tableObj?.[0]);
        this.dataSource.column = this.dataSource.column.map(el => {
          if (activeColumns.find(field => el.tabulatorInfo.field === field && field !== 'id')) {
            el.tabulatorInfo.visible = true;
          } else {
            el.tabulatorInfo.visible = false;
          }
          return el;
        });
        this.updateDiscoveryStatesCount(responseData.length);
        this.ztpJmepsTable.columns = this.dataSource.column;
        this.ztpJmepsTable.data = this.dataSource.data;
        this.ztpJmepsTable.minHeight = 250;
        this.ztpJmepsTable.height = 400;
        if (this.ztpJmepsTable.persistence) {
          this.ztpJmepsTable.persistence.sort = true;
          this.ztpJmepsTable.persistence.page = true;
          this.ztpJmepsTable.initialSort = [{ column: 'ipAddress', dir: 'asc' }];
        }
        this.ztpJmepsTable = Object.assign({}, this.ztpJmepsTable);
    }else {
      this.showDiscoveyResTable = false;
    }
  }

  removeDiscoverDetails(): void {
    const selecteIds = this.getSelectedItemsIds();
    this.savingInProgress = true;
    this.createZTPPostData(this.dataOptions.ipaddress.sectionName, selecteIds);
    this.requestJSONFormat.value.data = this.finalUpdatedFieldsOptions;
    this.jmepDiscoverService
    .removeZTPDiscovery({ url: this.esamURL, option: this.requestJSONFormat })
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(response => {
      if (response) {
        this.removeDiscoverComplete(response);
      }
    });
  }

  //eslint-disable-next-line
  removeDiscoverComplete(response: any): void {
    this.savingInProgress = false;
    this.getZTPDiscovery();
    if (response.status === 'success') {
      this.notificationService.onSuccess('ZTP addresses successfully removed.');
    }
    else {
      this.notificationService.onFail('ZTP remove failed: 404 Service not found : ' + response.data.message);
    }
  }

  //eslint-disable-next-line
  createZTPPostData(section: string, fieldValues: any): void {
    const subAttributesArray = [];
    fieldValues.forEach(value => {
      subAttributesArray.push({
        id: "jmep-id",
        value: value,
      });
    });
    this.finalUpdatedFieldsOptions.push({ name: section, value: null, subAttributes: subAttributesArray });
  }

  //eslint-disable-next-line
  getAttributeSection(responseData:any , section: string): any {
    const ipOption = responseData.find(data => data.id === section);
    return ipOption ? ipOption.value : '';
  }

  //eslint-disable-next-line
  getTableObject(item:any): any {
    item = item.subAttributes;
    this.discoveryErrorMessage = null;
    const announcedTime = this.getAttributeSection(item, 'announced-time');
    return {
      id: this.getAttributeSection(item, 'jmep-id'),
      ipAddress: this.getAttributeSection(item, "ip"),
      probeId: this.getAttributeSection(item, 'jmep-id'),
      announced: this.getDateTimeFormatted(parseInt(announcedTime)),
      activateStatus: this.getActivationStatus(item),
      processState: this.getProcessedStatus(item),
      errorMsg: (this.discoveryErrorMessage === null ? '' : this.discoveryErrorMessage)
    };
  }

  getDateTimeFormatted(timestamp: number): any {
    return {
      label: Number.isInteger(timestamp) ? this.dateFormatterService.getDate(timestamp, 'YYYY-MM-DD') : '',
      sublabel: Number.isInteger(timestamp) ? this.dateFormatterService.getTime(timestamp, 'HH:mm') : ''
    };
  }

  //eslint-disable-next-line
  getProcessedStatus(res: any): any {
      const processedStatus = this.getAttributeSection(res, 'processed-status');
      const processedTime = this.getDateTimeFormatted(parseInt(this.getAttributeSection(res, 'processed-time')));
      switch (processedStatus) {
        case 'succeeded':
          this.processedCount++;
          return {
            label: 'succeeded',
            icon: 'mdi-check',
            customClass: 'success',
            text: processedTime.label,
            subText: processedTime.sublabel,
          };
        case 'failed':
          if(this.discoveryErrorMessage === null) {
            this.discoveryErrorMessage = this.getAttributeSection(res, 'processed-message');
           this.errorCount++;
          }
          return {
            label: 'failed',
            icon: 'mdi-close',
            customClass: 'failed',
          };
        case 'skipped':
          if(this.discoveryErrorMessage === null) {
            this.discoveryErrorMessage = this.getAttributeSection(res, 'processed-message');
          }
          return {
            label: 'skipped',
            icon: 'mdi-minus',
            customClass: 'none'
          };
      }
    }

  //eslint-disable-next-line
  getActivationStatus(res: any): any {
    const activationStatus = this.getAttributeSection(res, 'activation-status');
    const activatedTime = this.getDateTimeFormatted(parseInt(this.getAttributeSection(res, 'activated-time')));
    switch (activationStatus) {
      case 'succeeded':
        this.activatedCount++;
        return {
          label: 'succeeded',
          icon: 'mdi-check',
          customClass: 'success',
          text: activatedTime.label,
          subText: activatedTime.sublabel,
        };
      case 'failed':
        if(this.discoveryErrorMessage === null) {
          this.discoveryErrorMessage = this.getAttributeSection(res, 'activation-message');
          this.errorCount++;
        }
        return {
          label: 'failed',
          icon: 'mdi-close',
          customClass: 'failed',
        };
      case 'skipped':
        if(this.discoveryErrorMessage === null) {
          this.discoveryErrorMessage = this.getAttributeSection(res, 'activation-message');
        }
        return {
          label: 'skipped',
          icon: 'mdi-minus',
          customClass: 'none'
        };
    }
  }

  updateDiscoveryStatesCount(discoveredCount: number): void {
    this.ztpDiscoverySates.forEach((status,index) => {
      switch(status.title) {
        case 'Discovered':
          this.ztpDiscoverySates[index]['count'] = discoveredCount;
          this.ztpDiscoverySates[index]['stateClass'] = (discoveredCount > 0) ? 'succeeded' : 'failed';
          break;
        case 'Activated':
          this.ztpDiscoverySates[index]['count'] = this.activatedCount;
          this.ztpDiscoverySates[index]['stateClass'] = (discoveredCount === this.activatedCount) ? 'succeeded' : 'failed';
          break;
        case 'Processed':
          this.ztpDiscoverySates[index]['count'] = this.processedCount;
          this.ztpDiscoverySates[index]['stateClass'] = (discoveredCount === this.processedCount) ? 'succeeded' : 'failed';
          break;
        case 'Error':
          this.ztpDiscoverySates[index]['count'] = this.errorCount;
          this.ztpDiscoverySates[index]['stateClass'] = (this.errorCount > 0) ? 'failed' : 'succeeded';
          break;
      }
    });
  }

  private getSelectedItemsIds(): string[] {
    let selectedItems = [];
    if(this.ztpDiscoveryTable.selection.length) {
      selectedItems = this.ztpDiscoveryTable.selection.map(list => {
        return list.probeId;
      });
    }
    return selectedItems;
  }

  get isRemoveActionDisabled(): boolean {
    return this.ztpDiscoveryTable?.selection?.length > 0;
  }
}
